import { createAction } from '@reduxjs/toolkit'

import { TResourceStatusResponse } from 'redux/api/ResourceStatuses'

export const getResourceStatuses = createAction('get_resource_statuses')
export const getResourceStatusesSuccess =
  createAction<TResourceStatusResponse>('get_resource_statuses_success')
export const getResourceStatusesFailed = createAction(
  'get_resource_statuses_failed'
)

export const putResourceStatus = createAction('put_resource_status')
export const putResourceStatusSuccess =
  createAction<TResourceStatusResponse>('put_resource_status_success')
export const putResourceStatusFailed = createAction(
  'put_resource_status_failed'
)
